// extracted by mini-css-extract-plugin
export default {"accordion":"styles_accordion__1sgfD","lang__item":"styles_lang__item__WZ3xP","lang__header":"styles_lang__header__bHBnG","lang__body":"styles_lang__body__LevGR"};